import styled from "styled-components";
import { Helmet } from "react-helmet-async";

const Page = styled.div`
  min-height: 70vh;
  padding: 48px 24px 80px;
  background: ${p => p.theme.colors.homeNavy};
  color: ${p => p.theme.colors.homeText};
  h1, h2, h3 { color: ${p => p.theme.colors.homeGold}; }
  h1 { font-size: clamp(2.5rem, 6vw, 4rem); }
  h2 { font-size: clamp(1.8rem, 4vw, 2.5rem); margin-bottom: 12px; }
  h3 { font-size: 1.3rem; line-height: 1.4; margin: 16px 0 8px; }
  p { line-height: 1.7; }
`;
const Content = styled.div`max-width: 1120px; margin: auto;`;
const Intro = styled.header`text-align: center; margin-bottom: 56px;`;
const Section = styled.section`margin-top: 56px;`;
const Grid = styled.div`
  display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 24px; margin-top: 28px;
  @media (max-width: 900px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 540px) { grid-template-columns: 1fr; }
`;
const Card = styled.article`
  padding: 20px;
  background: ${p => p.theme.colors.homeSurface};
  border: 1px solid #24495a; border-radius: 8px;
  img { display: block; width: 100%; height: 280px; object-fit: contain; }
`;
const Available = styled(Card)`
  display: grid; grid-template-columns: minmax(180px, 260px) 1fr; gap: 32px;
  align-items: center; margin-top: 28px;
  img { height: auto; max-height: 380px; }
  @media (max-width: 540px) { grid-template-columns: 1fr; gap: 12px; }
`;
const AmazonLink = styled.a`
  display: inline-flex; margin-top: 20px; padding: 12px 24px;
  border: 1px solid ${p => p.theme.colors.homeGold}; border-radius: 4px;
  background: #104951; color: ${p => p.theme.colors.homeGold}; font-weight: 700;
  &:hover { background: #17616b; color: ${p => p.theme.colors.homeGold}; }
  &:focus-visible { outline: 3px solid ${p => p.theme.colors.accent}; outline-offset: 4px; }
`;
const developmentBooks = [
  { title: "Harmonic Magnetism", image: "harmonic-magnetism.png" },
  { title: "The Red Letters", image: "the-red-letters.png" },
  { title: "Music Therapy and Human Transitions", author: "Taryn Thomas", image: "music-therapy-and-human-transitions.png" },
  { title: "A Chapter in the Book of Testimony", author: "Craig Crawford", image: "a-chapter-in-the-book-of-testimony.png" },
];

export default function Books() {
  return <>
    <Helmet><title>Books - The Music Church</title><meta name="description" content="Explore available books and books in development from The Music Church community." /></Helmet>
    <Page><Content>
      <Intro><h1>Books</h1><p>Stories, faith, and creativity from our community.</p></Intro>
      <Section aria-labelledby="available-books">
        <h2 id="available-books">Available Books</h2>
        <Available>
          <img src="/images/mbi-books/diary-of-a-burned-out-pastor.jpeg" alt="Diary of a Burned Out Pastor by James C. Blocker — book cover" />
          <div><h3>Diary of a Burned Out Pastor</h3><p>James C. Blocker</p><p>A novel.</p>
            <AmazonLink href="https://a.co/d/0irRHu8c" target="_blank" rel="noopener noreferrer">View on Amazon ↗</AmazonLink>
          </div>
        </Available>
      </Section>
      <Section aria-labelledby="development-books">
        <h2 id="development-books">Books in Development</h2>
        <p>These books are currently in development.</p>
        <Grid>{developmentBooks.map(book => <Card key={book.title}>
          <img src={`/images/mbi-books/${book.image}`} alt={`${book.title}${book.author ? ` by ${book.author}` : ""} — cover artwork`} loading="lazy" decoding="async" />
          <h3>{book.title}</h3>{book.author && <p>{book.author}</p>}
        </Card>)}</Grid>
      </Section>
    </Content></Page>
  </>;
}
